export default __webpack_public_path__ + "static/568-ca957982be7d46f32e7d5df7a0c76b23.gif";